import lodash from "lodash";

export function stickyNotification(window, sticky, notification) {
  if (window.scrollY > sticky) {
    notification.style.position = "fixed";
  } else {
    notification.style.position = "";
  }
}

export function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export function getImageDimention(imgData) {
  return new Promise((resolve) => {
    const img = new Image();
    img.src = imgData;

    img.onload = () => {
      resolve({ width: img.width, height: img.height });
    };
  });
}

export const asyncGetState = async (setStateFunc) => {
  return new Promise((resolve) => {
    setStateFunc((preState) => {
      resolve(preState);
      return preState;
    });
  });
};

export const cropImages = async (dataUrl, coordinates) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = function () {
      let _dataUrl;
      const { out_minxs, out_minys } = coordinates;
      if (out_minxs && out_minys) {
        let out_minx = Math.min(...out_minxs);
        let out_miny = Math.min(...out_minys);

        let out_maxx = Math.max(...out_minxs);
        let out_maxy = Math.max(...out_minys);

        let width = out_maxx - out_minx;
        let height = out_maxy - out_miny;

        let canvasSnapshot = document.createElement("canvas");
        canvasSnapshot.width = width;
        canvasSnapshot.height = height;

        let contextSnapshot = canvasSnapshot.getContext("2d");
        contextSnapshot.fillRect(0, 0, width, height);
        contextSnapshot.imageSmoothingEnabled = false;
        contextSnapshot.drawImage(img, out_minx, out_miny, width, height, 0, 0, width, height);
        _dataUrl = canvasSnapshot.toDataURL("image/jpeg", 1.0);
      }
      resolve(_dataUrl);
    };
    img.src = dataUrl;
  });
};

export const resizeImage = async (dataUrl, imgWidth, imgHeight) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = function () {
      const canvasSnapshot = document.createElement("canvas");
      const aspectRatio = imgWidth > imgHeight ? imgWidth / imgHeight : imgHeight / imgWidth;
      const isLandscape = imgWidth > imgHeight ? true : false;
      const fixedCanvasWidth = 350;
      const fixedCanvasHeight = isLandscape ? 350 / aspectRatio : 350 * aspectRatio;

      canvasSnapshot.width = fixedCanvasWidth;
      canvasSnapshot.height = fixedCanvasHeight;

      const contextSnapshot = canvasSnapshot.getContext("2d");
      contextSnapshot.fillRect(0, 0, fixedCanvasWidth, fixedCanvasHeight);
      contextSnapshot.imageSmoothingEnabled = false;
      contextSnapshot.drawImage(img, 0, 0, fixedCanvasWidth, fixedCanvasHeight);
      const dataUrl = canvasSnapshot.toDataURL("image/jpeg", 1.0);
      const dataPNGUrl = canvasSnapshot.toDataURL();
      resolve({ dataUrl, dataPNGUrl });
    };
    img.src = dataUrl;
  });
};

export function setObjectProperty(obj, path, value) {
  if (!obj) {
    return null;
  }
  if (!path) {
    return obj;
  }

  const a = path.split(".");
  let o = obj;
  while (a.length - 1) {
    const n = a.shift();
    if (!(n in o)) o[n] = {};
    o = o[n];
  }
  o[a[0]] = value;

  return o;
}

export function setObjectPropertyWithClone(obj, path, value) {
  const sss = JSON.parse(JSON.stringify(obj));
  if (!sss) {
    return null;
  }
  if (!path) {
    return sss;
  }

  const a = path.split(".");
  let o = sss;
  while (a.length - 1) {
    const n = a.shift();
    if (!(n in o)) o[n] = {};
    o = o[n];
  }
  o[a[0]] = value;

  return sss;
}

export const fetchMoreAlerts = ({
  alerts,
  totalAlerts,
  size,
  page,
  user,
  getAlerts,
  setHasMore,
  setAlerts,
  setPage,
}) => {
  if (alerts.length >= totalAlerts) {
    setHasMore(false);
    return;
  }
  getAlerts(size, page + 1, user?.uid).then((res) => {
    setAlerts(alerts.concat(res.alerts));
    setPage(page + 1);
  });
};

const hasKey = (obj, key) => {
  return obj.hasOwnProperty(key);
};

export const hasRevenueCatSub = (userStatus) => {
  if (!userStatus) return false;
  if (lodash.isEmpty(userStatus?.subscriptions)) return false;

  const subscriptions = userStatus?.subscriptions;
  return !lodash.isEmpty(subscriptions.filter((sub) => hasKey(sub, "revenueCat")));
};
